// The tokens each event makes available, mirrored from the backend's payloads, plus
// sample values so the builder can render a live preview. Keeping this here means an
// admin sees which {{tokens}} are valid for the event they're editing and what the
// message will look like — instead of guessing and getting silent blanks.

export interface TokenInfo { token: string; sample: string; }

export const EVENT_TOKENS: Record<string, TokenInfo[]> = {
  PaymentRecorded: [
    { token: 'tenantName', sample: 'Greenwood Trust' },
    { token: 'studentName', sample: 'Aarav Sharma' },
    { token: 'guardianName', sample: 'Meera Sharma' },
    { token: 'invoiceNumber', sample: 'INV-2026-00042' },
    { token: 'amount', sample: '₹12,500.00' },
    { token: 'balance', sample: '₹7,500.00' },
  ],
  InvoiceRaised: [
    { token: 'tenantName', sample: 'Greenwood Trust' },
    { token: 'studentName', sample: 'Aarav Sharma' },
    { token: 'guardianName', sample: 'Meera Sharma' },
    { token: 'invoiceNumber', sample: 'INV-2026-00042' },
    { token: 'amount', sample: '₹20,000.00' },
  ],
  FeesOverdue: [
    { token: 'tenantName', sample: 'Greenwood Trust' },
    { token: 'studentName', sample: 'Aarav Sharma' },
    { token: 'guardianName', sample: 'Meera Sharma' },
    { token: 'invoiceNumber', sample: 'INV-2026-00042' },
    { token: 'balance', sample: '₹7,500.00' },
  ],
  StudentEnrolled: [
    { token: 'tenantName', sample: 'Greenwood Trust' },
    { token: 'studentName', sample: 'Aarav Sharma' },
    { token: 'admissionNumber', sample: '2026-0412' },
  ],
  Welcome: [
    { token: 'tenantName', sample: 'Greenwood Trust' },
    { token: 'name', sample: 'Meera Sharma' },
  ],
  StudentAbsent: [
    { token: 'tenantName', sample: 'Greenwood Trust' },
    { token: 'studentName', sample: 'Aarav Sharma' },
    { token: 'guardianName', sample: 'Meera Sharma' },
    { token: 'date', sample: '11 Jul 2026' },
  ],
};

export const EVENT_LABEL: Record<string, string> = {
  PaymentRecorded: 'Payment received',
  InvoiceRaised: 'Invoice raised',
  FeesOverdue: 'Fees overdue',
  StudentEnrolled: 'Student enrolled',
  Welcome: 'Welcome',
  StudentAbsent: 'Student absent',
};

export const CHANNEL_LABEL: Record<string, string> = {
  Email: 'Email',
  Sms: 'SMS',
  InApp: 'In-app',
  Push: 'Push',
};

// Render a preview by substituting sample values, mirroring the backend renderer:
// unknown tokens are stripped to blank (so a typo shows as a gap, same as production).
export function renderPreview(template: string, tokens: TokenInfo[]): string {
  let out = template;
  for (const t of tokens) out = out.split(`{{${t.token}}}`).join(t.sample);
  return out.replace(/\{\{[^}]+\}\}/g, '');
}

// Which channels support a subject (email only) and which are HTML vs plain text.
export const CHANNEL_HAS_SUBJECT = (channel: string) => channel === 'Email';
export const CHANNEL_IS_HTML = (channel: string) => channel === 'Email';
